__turbopack_context__.v({
  "brandCard": "styles-module-scss-module__qKRW3W__brandCard",
  "brandImage": "styles-module-scss-module__qKRW3W__brandImage",
  "brandInitial": "styles-module-scss-module__qKRW3W__brandInitial",
  "brandName": "styles-module-scss-module__qKRW3W__brandName",
  "brandsGrid": "styles-module-scss-module__qKRW3W__brandsGrid",
  "filterControls": "styles-module-scss-module__qKRW3W__filterControls",
  "introText": "styles-module-scss-module__qKRW3W__introText",
  "mantineInput": "styles-module-scss-module__qKRW3W__mantineInput",
  "searchInput": "styles-module-scss-module__qKRW3W__searchInput",
});
